/**
 * 파일명의 확장자를 기반으로 Monaco Editor 언어 코드를 반환
 * @param {string} fileName - 파일명 (예: "Main.java", "app.py")
 * @returns {string} Monaco Editor 언어 코드
 */
export const getMonacoLanguage = (fileName) => {
  if (!fileName || typeof fileName !== 'string') {
    return 'plaintext';
  }

  // 파일명에서 확장자 추출
  const extension = fileName.split('.').pop()?.toLowerCase();

  const extensionMap = {
    // Python
    'py': 'python',
    'pyw': 'python',
    
    // Java
    'java': 'java',
    'class': 'java',
    'jar': 'java',
    
    // Gradle (Groovy DSL / Kotlin DSL)
    'gradle': 'java',      // build.gradle - Groovy DSL (Java와 유사한 문법)
    'kts': 'kotlin',       // build.gradle.kts - Kotlin DSL
    
    // C
    'c': 'c',
    'h': 'c',
    
    // C++
    'cpp': 'cpp',
    'cxx': 'cpp',
    'cc': 'cpp',
    'hpp': 'cpp',
    'hxx': 'cpp',
    
    // C#
    'cs': 'csharp',
    
    // JavaScript
    'js': 'javascript',
    'jsx': 'javascript',
    'mjs': 'javascript',
    
    // TypeScript
    'ts': 'typescript',
    'tsx': 'typescript',
    
    // 기타
    'html': 'html',
    'css': 'css',
    'json': 'json',
    'config': 'xml',
    'xml': 'xml',
    'sql': 'sql',
    'sh': 'shell',
    'bash': 'shell',
    'md': 'markdown',
    'yml': 'yaml',
    'yaml': 'yaml',
    'properties': 'properties',
    'conf': 'properties',
    'ini': 'properties',
  };

  return extensionMap[extension] || 'plaintext';
};
